/** Canonical role_id → display label for admin UI. */
export const ROLE_ID_LABELS = {
  r1: "Super Admin",
  r2: "Admin",
  r3: "Coach",
  r4: "Player",
  r5: "Expert Coach",
  r6: "Monitor",
  r7: "Guest Player",
  r8: "Parent",
  r9: "Moderator",
  r10: "Committee Member",
};

/**
 * Resolve a role id / row / name into a human label.
 * @param {string|{role_id?: string, role_name?: string}|null|undefined} role
 * @returns {string}
 */
export function formatRoleLabel(role) {
  if (role == null) return "Unknown";
  if (typeof role === "object") {
    const name = String(role.role_name || "").trim();
    if (name) return name;
    return formatRoleLabel(role.role_id);
  }
  const raw = String(role).trim();
  if (!raw) return "Unknown";
  const key = raw.toLowerCase();
  if (ROLE_ID_LABELS[key]) return ROLE_ID_LABELS[key];
  // Already a display name (e.g. from all_role_names)
  if (!/^r\d+$/i.test(raw)) return raw;
  return raw.toUpperCase(); // last resort for unknown rN — avoid CSS capitalize surprises
}

/**
 * @param {string[]|undefined|null} roleIds
 * @param {string[]|undefined|null} roleNames
 * @returns {string[]}
 */
export function formatRoleLabels(roleIds, roleNames) {
  if (Array.isArray(roleNames) && roleNames.length > 0) {
    return roleNames.map((n) => formatRoleLabel(n)).filter(Boolean);
  }
  if (!Array.isArray(roleIds) || roleIds.length === 0) return [];
  return roleIds.map((id) => formatRoleLabel(id));
}

export function roleBadgeColor(roleName) {
  switch (roleName) {
    case "Coach":
      return "#2e7d32";
    case "Expert Coach":
    case "Expert-Coach":
      return "#00695c";
    case "Monitor":
      return "#558b2f";
    case "Moderator":
      return "#4527a0";
    case "Guest Player":
      return "#6a1b9a";
    case "Player":
      return "#1976d2";
    case "Admin":
      return "#ed6c02";
    case "Committee Member":
      return "#0277bd";
    case "Super Admin":
      return "#9c27b0";
    case "Parent":
      return "#455a64";
    default:
      return "#607d8b";
  }
}
